import { format, isSameDay, isSameMonth, isSameYear } from 'date-fns';
import zonedDate from './zoned-date';

export default function (startDate, endDate = null) {
    if (!startDate) {
        return null;
    }

    const now = zonedDate();

    if (!endDate) {
        endDate = startDate;
    }

    if (isSameDay(startDate, endDate)) {
        if (isSameYear(startDate, now)) {
            return format(startDate, 'MMM d');
        }

        return format(startDate, 'MMM d, yyyy');
    }

    if (isSameMonth(startDate, endDate)) {
        if (isSameYear(startDate, now)) {
            return `${format(startDate, 'MMM d')} – ${format(endDate, 'd')}`;
        }

        return `${format(startDate, 'MMM d')} – ${format(endDate, 'd, yyyy')}`;
    }

    if (isSameYear(startDate, endDate)) {
        if (isSameYear(startDate, now)) {
            return `${format(startDate, 'MMM d')} – ${format(endDate, 'MMM d')}`;
        }

        return `${format(startDate, 'MMM d')} – ${format(endDate, 'MMM d, yyyy')}`;
    }

    return `${format(startDate, 'MMM d, yyyy')} – ${format(endDate, 'MMM d, yyyy')}`;
}
